module.exports = __webpack_public_path__ + "img/signature.a3ba232f.png";